var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcAvatarPremium = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 13,
  fill: "none",
  viewBox: "0 0 36 13",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-4217012065__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35.657,
  height: 12,
  y: 0.137,
  fill: "url(#svg-4217012065__b)",
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.918 6.072q.375 0 .54-.19.165-.191.165-.533 0-.151-.043-.276a.54.54 0 0 0-.13-.212.55.55 0 0 0-.22-.139.9.9 0 0 0-.312-.048h-.5v1.398zm0-2.164q.438 0 .75.112.315.11.518.303t.3.457q.097.263.097.569 0 .33-.099.605a1.2 1.2 0 0 1-.304.472q-.205.196-.52.308a2.3 2.3 0 0 1-.742.11h-.5v1.473h-.96V3.908zM9.418 5.981q.196 0 .333-.051a.566.566 0 0 0 .355-.366 1 1 0 0 0 .04-.273q0-.29-.18-.454-.176-.163-.548-.163h-.386V5.98zm2.04 2.336h-.869q-.242 0-.347-.194l-.688-1.28a.33.33 0 0 0-.108-.118.3.3 0 0 0-.17-.039H9.03v1.631h-.96V3.908h1.347q.45 0 .765.1.318.097.517.272.201.176.293.415.09.24.09.52 0 .216-.053.406a1.26 1.26 0 0 1-.42.641q-.155.128-.356.21a.8.8 0 0 1 .176.13.9.9 0 0 1 .148.18zM12.773 4.695v1.029h1.302v.756h-1.302v1.05h1.7v.787h-2.666V3.908h2.666v.787zM19.72 3.908v4.409h-.846V5.781q0-.087.002-.19.006-.104.017-.21l-1.1 2.267a.356.356 0 0 1-.335.215h-.13a.37.37 0 0 1-.2-.054.4.4 0 0 1-.136-.16l-1.1-2.273a9 9 0 0 1 .02.405v2.536h-.847V3.908h.733q.063 0 .108.003a.3.3 0 0 1 .086.018.2.2 0 0 1 .065.049q.03.03.06.088l1.066 2.236q.055.114.108.239.053.123.102.254a3.47 3.47 0 0 1 .213-.502l1.063-2.227a.4.4 0 0 1 .057-.088.2.2 0 0 1 .068-.049.3.3 0 0 1 .082-.018q.05-.003.111-.003zM21.488 8.317h-.966V3.908h.966zM24.015 7.51a.84.84 0 0 0 .344-.067.7.7 0 0 0 .258-.197.9.9 0 0 0 .16-.309q.056-.184.056-.417V3.908h.961V6.52q0 .405-.125.744-.122.339-.352.584a1.6 1.6 0 0 1-.56.381q-.33.136-.742.136-.415 0-.745-.136a1.59 1.59 0 0 1-.912-.965 2.2 2.2 0 0 1-.122-.744V3.908h.96v2.609q0 .232.054.417a.9.9 0 0 0 .163.312q.105.127.255.197a.9.9 0 0 0 .347.066M31.2 3.908v4.409h-.847V5.781l.003-.19q.006-.104.017-.21l-1.1 2.267a.356.356 0 0 1-.335.215h-.131a.37.37 0 0 1-.199-.054.4.4 0 0 1-.136-.16l-1.1-2.273a9 9 0 0 1 .02.405v2.536h-.847V3.908h.733q.063 0 .108.003a.3.3 0 0 1 .085.018.2.2 0 0 1 .066.049q.03.03.06.088l1.065 2.236q.057.114.108.239.054.123.102.254a3.47 3.47 0 0 1 .213-.502l1.063-2.227a.4.4 0 0 1 .057-.088.2.2 0 0 1 .069-.049.3.3 0 0 1 .082-.018q.049-.003.11-.003z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-4217012065__b",
  x1: 0,
  x2: 5.365,
  y1: 0.137,
  y2: 20.227,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF465D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F711BA"
})), /*#__PURE__*/React.createElement("filter", {
  id: "svg-4217012065__a",
  width: 40.312,
  height: 16.655,
  x: -2.328,
  y: -2.191,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 1.164
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_8483_2929"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_8483_2929",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAvatarPremium);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };